import React from "react";
import styles from "./BuiltInIndia.module.css";
import { INDIA_MAP } from "../assets";

export default function BuiltInIndia() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.inner}>
          <div className={styles.copy}>
            <h2 className={styles.title}>
              <span className={styles.titleGradient}>Built in India.</span>
              <span className={styles.titleDark}>Expanding Globally.</span>
            </h2>

            <p className={styles.stat}>
              <span className={styles.statBold}>15+</span>
              <span className={styles.statLight}> States</span>
            </p>
            <p className={styles.stat}>
              <span className={styles.statBold}>250+ </span>
              <span className={styles.statLight}>Customers</span>
            </p>

            <p className={styles.body}>
              <span className={styles.bodyBold}>150+</span>
              <span className={styles.bodyLight}>
                {" "}
                specialists on the ground across India, working
                shoulder-to-shoulder with plant teams. This combination of deep
                tech and physical presence means faster deployment, measurable
                impact from day one, and continuous improvement built into every
                customer plant, wherever they operate.
              </span>
            </p>
          </div>

          <div className={styles.mapWrap}>
            <img
              src={INDIA_MAP}
              alt="Map of India showing MetalCloud customer plants across 15+ states"
              className={styles.map}
              loading="lazy"
              width={720}
              height={800}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
